import { Tag, type TagProps } from "antd"
import React from "react"

import { cn } from "../../../utils/cn.ts"

interface LeadPillProps extends Omit<TagProps, "icon"> {
  icon?: React.ReactNode
}

/**
 * The status and operational-state chips have to be the same object at two
 * different jobs — the table shows them side by side, and the mockup gives both
 * the same outlined pill. Rendering them through one component is what keeps
 * their padding, radius and icon alignment from drifting apart.
 *
 * The ref and the remaining props are forwarded because `Dropdown` clones its
 * trigger to inject them; swallowing either leaves the status pill unopenable.
 */
export const LeadPill = React.forwardRef<HTMLSpanElement, LeadPillProps>(
  ({ icon, className, children, ...rest }, ref) => (
    <Tag
      ref={ref}
      className={cn(
        "m-0 inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 font-medium",
        className
      )}
      {...rest}
    >
      {/* antd's own `icon` prop applies a margin the flex gap already owns. */}
      {icon ? <span className={"shrink-0 text-[1.05em]"}>{icon}</span> : null}
      {children}
    </Tag>
  )
)

LeadPill.displayName = "LeadPill"
